import { UpdateSecondHandSupplyService } from './../../services/update-second-hand-supply.service';
import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';

@Component({
  selector: 'app-send-for-approval',
  templateUrl: './send-for-approval.component.html',
  styleUrls: ['./send-for-approval.component.scss']
})
export class SendForApprovalComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<SendForApprovalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    private updateSecondHandSupplyService: UpdateSecondHandSupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  async updateSupply(){
    try {
      await this.updateSecondHandSupplyService.updateSecondHandSupplyByPk(this.data.id, {status: 'PENDING_APPROVAL'});
      this.toast.openSnackBar("successfully this pre owned supplies is sent for approval");
      this.closeDialog('yes');
    } catch(error){
      this.toast.openSnackBar("Unable to send for approval");
    }
  }
}

